import APICaller from '@/shared/mixins/APICaller';
import { fundamentalSnapshot, fundamentalActivities, hasFundamentalData } from '../models/fundamentalSnapshot';

export default {
  data() {
    return { fundamentalRevision: 0, fundamentalTicker: '', fundamentalPending: false,
      loading_fundamental: false, fundamental_available: false, loadError: '', table_body_activities: [] };
  },
  watch: {
    'selected_stock.ticker'() {
      this._resetFundamentalForTicker();
      if (this.active_right_component === 'fundamental' || this._g_open_fundamental) this._getFundamentalInfo();
    }
  },
  beforeDestroy() { this.fundamentalRevision++; },
  methods: {
    _resetFundamentalForTicker() {
      const ticker = (this.selected_stock && this.selected_stock.ticker) || '';
      if (ticker === this.fundamentalTicker) return;
      this.fundamentalRevision++;
      this.fundamentalTicker = ticker;
      this.fundamentalPending = false;
      this.last_stock_loaded = '';
      this.loading_fundamental = false;
      this.fundamental_available = false;
      this.loadError = '';
      Object.assign(this, fundamentalSnapshot(null));
    },
    _fundamentalRequestIsCurrent(ticker, revision) {
      return !this._isDestroyed && !this._isBeingDestroyed && this.fundamentalRevision === revision &&
        this.selected_stock && this.selected_stock.ticker === ticker;
    },
    _getFundamentalInfo() {
      this._resetFundamentalForTicker();
      if (!this._g_UserFeatures.permissions.fundamental_analisis) return;
      const ticker = this.fundamentalTicker;
      if (!ticker || this.fundamentalPending || this.last_stock_loaded === ticker) return;
      const revision = ++this.fundamentalRevision;
      this.fundamentalPending = true;
      this.loading_fundamental = true;
      this.fundamental_available = false;
      this.loadError = '';
      if (this._g_User) this.user_is_developer_or_jota = this._g_User.is_developer_user || this._g_User.uid == '15';
      const fail = () => {
        if (!this._fundamentalRequestIsCurrent(ticker, revision)) return;
        this.fundamentalPending = false;
        this.loading_fundamental = false;
        this.last_stock_loaded = '';
        this.fundamental_available = false;
        this.loadError = 'No se pudo cargar el análisis fundamental. Vuelva a abrir el panel para reintentarlo.';
      };
      const success = response => {
        if (!this._fundamentalRequestIsCurrent(ticker, revision)) return;
        const data = response.data;
        Object.assign(this, fundamentalSnapshot(data));
        if (this._translateActivities) this.table_body_activities = fundamentalActivities(data, this._translateActivities.bind(this));
        this.fundamental_available = hasFundamentalData(data);
        this.last_stock_loaded = ticker;
        this.fundamentalPending = false;
        this.loading_fundamental = false;
        // Child charts mount/watch their series themselves; no polling or old chart instances.
        if (this.fundamental_available) this._getDataFromScrapper();
      };
      return this._getAPICall('/api/v1/stocks/fundamental/' + encodeURIComponent(ticker),
        new APICaller.SuccessHandler(success), new APICaller.FailureHandler('050', 'Error al obtener análisis fundamental.', fail), { timeoutMs: 30000 });
    },
    _getDataFromScrapper() {
      const ticker = this.fundamentalTicker, revision = this.fundamentalRevision;
      this.cargando_numero_empleados = true;
      this.employees_data = [];
      const fail = () => {
        if (!this._fundamentalRequestIsCurrent(ticker, revision)) return;
        this.cargando_numero_empleados = false;
        this.no_employees_info = true;
      };
      const success = response => {
        if (!this._fundamentalRequestIsCurrent(ticker, revision)) return;
        const rows = Array.isArray(response.data) ? response.data : [];
        this.employees_data = rows.filter(row => row && Number(row.employees) > 0 && Number.isFinite(Number(row.year)))
          .map(row => [Number(row.year), Number(row.employees)]);
        this.no_employees_info = this.employees_data.length === 0;
        this.cargando_numero_empleados = false;
      };
      return this._getAPICall('/api/v1/stocks/scrap_employees/' + encodeURIComponent(ticker),
        new APICaller.SuccessHandler(success), new APICaller.FailureHandler('313', 'Error recuperando los datos de empleados.', fail), { loadingOverlay: false, timeoutMs: 30000 });
    }
  }
};
